/**
 * Parses the JWT payload (middle segment). Does not verify the signature.
 * @param {string | null | undefined} accessToken
 * @returns {Record<string, unknown> | null}
 */
export function decodeJwtPayload(accessToken) {
  if (!accessToken || typeof accessToken !== "string") return null;
  const segments = accessToken.split(".");
  if (segments.length < 2) return null;
  try {
    let base64 = segments[1].replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) base64 += "=";
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}
